import { uniqBy } from 'lodash'
import { ChargingSessionModel } from 'src/Libs/e-mobility/charging-sessions'
import { ChargingSessionStatus } from 'src/Libs/e-mobility/charging-sessions/types'

/** Hook to populate charging sessions status filter with unique status values*/
export const useChargingSessionsStatusFilterOptions = (sessions: ChargingSessionModel[] | undefined): ChargingSessionStatus[] => {
  const statusFilterOptions: ChargingSessionStatus[] = sessions
    ? uniqBy(
        sessions.map(session => session.status),
        status => status
      )
    : []

  return statusFilterOptions
}
